var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8607 8.65577C14.8607 14.0346 9.35149 17.3484 8.2066 17.9795C8.14318 18.0145 8.07192 18.0329 7.99949 18.0329C7.92706 18.0329 7.85581 18.0145 7.79238 17.9795C6.64664 17.3484 1.13916 14.0346 1.13916 8.65577C1.13916 4.36779 3.71195 1.36621 7.99992 1.36621C12.2879 1.36621 14.8607 4.36779 14.8607 8.65577Z",
    stroke: "#170F49",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56934 8.22677C4.56934 9.13656 4.93075 10.0091 5.57407 10.6524C6.21739 11.2957 7.08992 11.6571 7.99972 11.6571C8.90951 11.6571 9.78204 11.2957 10.4254 10.6524C11.0687 10.0091 11.4301 9.13656 11.4301 8.22677C11.4301 7.31697 11.0687 6.44444 10.4254 5.80112C9.78204 5.1578 8.90951 4.79639 7.99972 4.79639C7.08992 4.79639 6.21739 5.1578 5.57407 5.80112C4.93075 6.44444 4.56934 7.31697 4.56934 8.22677V8.22677Z",
    stroke: "#170F49",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.5229cc5e92b2e38d35fbc1e052b355f1.svg";
export { ForwardRef as ReactComponent };